import React, { useState } from "react";
import "./Header.css";
import Button from "../Button";
import { LoginModal } from "../LoginModal";
import { useAuth } from "../../contexts/AuthContext";
import { UserHeaderAvatar } from "../UserHeaderAvatar";
import { NotificationBell } from "./NotificationBell";
import { Link } from "react-router-dom";
import { IconCaretLeft } from "../icons/IconCaretLeft";
import { useEditMode } from "../../hooks/useEditMode";
import { CircleButton } from "../common/CircleButton/circle-button";

type AppHeaderProps = {
  title: string;
  subtitle?: string;
  iconUrl: string | null;
  setShowJoinForm: () => void;
  hasBackButton?: boolean;
  listingId: string;
};

export const AppHeader: React.FC<AppHeaderProps> = ({
  title,
  subtitle,
  setShowJoinForm,
  hasBackButton,
  iconUrl,
  listingId,
}) => {
  // STATE
  const [showLoginModal, setShowLoginModal] = useState(false);

  // HOOKS
  const { user, logout, loading } = useAuth();
  const { isEditMode, canEdit, toggleEditMode } = useEditMode({
    listingId: listingId,
    creatorIds: [],
  });

  // HANDLERS
  const handleLogout = async () => {
    try {
      await logout();
    } catch (error) {
      console.error("Logout error:", error);
    }
  };

  return (
    <>
      <header className="header">
        <div className="header__content">
          {hasBackButton && (
            <Link to="/" className="back-button">
              <IconCaretLeft />
            </Link>
          )}
          <div className="header__title-section">
            {iconUrl && (
              <img className="header__icon" src={iconUrl} alt="Icon" />
            )}
            <div className="header__title-text">
              <h1 className="header__title">{title}</h1>
              <h2 className="header__subtitle">{subtitle}</h2>
            </div>
          </div>
        </div>
        <div className="header-buttons">
          {!loading && !user && (
            <>
              <Button onClick={() => setShowLoginModal(true)}>
                <span className="button-text-full">Log in</span>
                <span className="button-text-mobile">Log in</span>
              </Button>
              <Button onClick={setShowJoinForm}>
                <span className="button-text-full">+ Join the network</span>
                <span className="button-text-mobile">+ Join</span>
              </Button>
            </>
          )}
          {!loading && user && (
            <>
              <NotificationBell />
              {canEdit && (
                <CircleButton
                  onClick={toggleEditMode}
                  ariaLabel={isEditMode ? "Exit edit mode" : "Enter edit mode"}
                  iconKey="edit"
                  state={isEditMode ? "active" : "normal"}
                  size="medium"
                />
              )}
              <UserHeaderAvatar />
              <Button onClick={handleLogout}>
                <span className="button-text-full">Log out</span>
                <span className="button-text-mobile">Log out</span>
              </Button>
            </>
          )}
        </div>
      </header>
      {showLoginModal && (
        <LoginModal onClose={() => setShowLoginModal(false)} />
      )}
    </>
  );
};
